import { RouteComponentProps } from "@reach/router";
import React, { FunctionComponent } from "react";

const styles = {
  container: {},
};

interface Props extends RouteComponentProps {}
const Administration: FunctionComponent<Props> = (props) => {
  const { children } = props;
  return <div style={styles.container}>{children}</div>;
};

export default Administration;
